import React, { useEffect, useRef, useState } from "react";

const ToggleButton = ({
    isToggled,
    onChangeToggle,
}: {
    isToggled: boolean;
    onChangeToggle: (isToggled: boolean) => void;
}) => {
    const [cambiando, setCambiando] = useState(true);
    const [initialState, setInitialState] = useState(isToggled);
    const [active, setActive] = useState(isToggled);
const toggleRef = useRef<HTMLDivElement>(null);
const backgroundRef = useRef<HTMLDivElement>(null);

    const onToggle = () => {
       
        if (initialState) {
            if (active) {
                if (toggleRef.current && backgroundRef.current) {
                toggleRef.current.classList.add("translate-x-[-1.9rem]");
                toggleRef.current.classList.replace(
                    "bg-[#029BFC]",
                    "bg-gray-300"
                );
                backgroundRef.current.classList.replace(
                    "bg-[#029BFC]",
                    "bg-gray-200"
                );
                }
            }
             else {
                if (toggleRef.current && backgroundRef.current) {
                toggleRef.current.classList.remove("translate-x-[-1.9rem]");
                toggleRef.current.classList.replace(
                    "bg-gray-300",
                    "bg-[#029BFC]"
                );
                backgroundRef.current.classList.replace(
                    "bg-gray-200",
                    "bg-[#029BFC]"
                );
                }
        
            }
        
    } else {
            if (!active) {
                if (toggleRef.current && backgroundRef.current) {
                toggleRef.current.classList.add("translate-x-[1.9rem]");
                toggleRef.current.classList.replace(
                    "bg-gray-300",
                    "bg-[#029BFC]"
                );
                backgroundRef.current.classList.replace(
                    "bg-gray-200",
                    "bg-[#029BFC]"
                );
                }
            } else {
         

                     if (toggleRef.current && backgroundRef.current) {
                toggleRef.current.classList.remove("translate-x-[1.9rem]");
                toggleRef.current.classList.replace(
                    "bg-[#029BFC]",
                    "bg-gray-300"
                );
                backgroundRef.current.classList.replace(
                    "bg-[#029BFC]",
                    "bg-gray-200"
                );
                     }
            }
        }
        setActive((prev) => !prev);
    }


    useEffect(() => {
        if (cambiando) {
            onChangeToggle(active);
        }
    }, [active]);

    return (
        <div
            ref={backgroundRef}
            className={`${
                initialState ? "bg-[#029BFC]" : "bg-gray-200"
            } w-16 h-8 rounded-2xl relative flex items-center cursor-pointer duration-200 ease-linear select-none bg-opacity-40 `}
            onClick={() => onToggle()}>
            <span
                ref={toggleRef}
                className={`${
                    initialState
                        ? "bg-[#029BFC] right-0.5"
                        : "bg-gray-300 left-0.5"
                } rounded-full duration-200 ease-linear h-[1.70rem] w-[1.70rem] absolute m-[2px]`}></span>
        </div>
    );
}

export default ToggleButton;
